import {Component, ElementRef, Inject, OnInit, ViewChild, DOCUMENT, inject, effect, ChangeDetectionStrategy} from '@angular/core';
import {MessengerService} from 'src/app/_services/messenger.service';
import {ApiService} from 'src/app/_services/api.service';
import {NgxSpinnerService} from 'ngx-spinner';

import {ChatServiceService} from 'src/app/_services/chatService.service';
import {TranslateService} from "@ngx-translate/core";
import {lastValueFrom} from "rxjs";
import {UserService} from '../../_services/user.service';
import {LanguageService} from '../../_services/language.service';


@Component({
    selector: 'app-chatbot',
    templateUrl: './chatbot.component.html',
    styleUrls: ['./chatbot.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatbotComponent implements OnInit {
  toggler = false;
  toggleDisplay = false;
  setMessage: string;
  toggleSpinner = false;
  @ViewChild('chatBox') private myScrollContainer: ElementRef;
  messages: Message[] = [

  ];

  private readonly userService = inject(UserService);
  private readonly languageService = inject(LanguageService);
  // chatBoxWrapper
  constructor(private messenger: MessengerService, private api: ApiService, private spinner: NgxSpinnerService, public chatService: ChatServiceService, @Inject(DOCUMENT) document,
              private translate: TranslateService
  ) {
    effect(() => {
      const user = this.userService.user();
      void this.loadInitialMessage(user?.firstName ? `, ${user.firstName}` : '').then();
    });
  }

  async loadInitialMessage(helloSuffix: string): Promise<void> {
    this.messages = [];
    let translated = await lastValueFrom(this.translate.get('ChatBot.Initial'));
    translated = translated.replace(/%hello-suffix%/g, helloSuffix);
    this.messages.push({ isUser: true, message: translated });
  }

  scrollBottom(el: string) {

    setTimeout(() => {
      const element = document.getElementById(el);
      element.scrollIntoView();

      document.getElementById("chat").scrollTop -= 100;
     }, 500);

  }
  ngOnInit() {
    this.showSpinner()
  }
  initConversation(text: string) {
    this.messenger.createThread({ Id: '2' }).subscribe( next => {
      console.log('Token Added Successfully');
      this.createMessage(text);
    }, error => {
      console.log('Token Failed');
    });
  }
  createMessage(text: string) {
    this.toggleSpinner = true;
    const lang = this.languageService.getActiveLanguage();
    if(lang != 'en') {
      this.api.translate(text, 'en').subscribe(item => {

        this.messenger.getMessage({ content: item.message, isMapRequest: false }, this.messenger.messengerInfo.id.toString()).subscribe(data => {
          this.api.translate(data.content, lang).subscribe(r => {
            this.toggleSpinner = false;
            this.messages.push({
              message: r.message,
              isUser: true
            })
            // this.scrollBottom();
            const el = document.getElementById("chat")
            el.scrollTop =  -el.scrollHeight

          })
        })
      });
    }
    else {
      this.messenger.getMessage({ content: text, isMapRequest: false }, this.messenger.messengerInfo.id.toString()).subscribe(data => {
        console.log(data);
        this.toggleSpinner = false;
        this.messages.push({
          id: data.id,
          message: data.content,
          isUser: true
        })
        this.scrollBottom(data.id.toString());

      }, error => {
        console.log('Error loading Information');
      });
    }

  }
  showSpinner() {
    this.spinner.show();
    // setTimeout(() => {
    //   this.spinner.hide();
    // }, 5000);
  }
  toggle() {
    if(!this.toggleDisplay){
      this.chatService.openChatBot();
      // this.toggler = !this.toggler
    // this.toggleDisplay = !this.toggleDisplay;
    }

  }


  addMessage(item: any) {

    if(item.value.msg == undefined || item.value.msg == null || item.value.msg == "")
    {
      return
    }
    if(!this.messenger.messengerInfo)
      this.initConversation(item.value.msg)
    else
      this.createMessage(item.value.msg);

    this.messages.push({
      message: item.value.msg,
      isUser: false
    })




  }

  addMessageManual(msg: string) {
    if(!this.messenger.messengerInfo)
      this.initConversation(msg)
    else
      this.createMessage(msg);
  }

}

interface Message {
  id?: number;
  message: string,
  isUser: boolean
}
